/**
 * @author       sarah.walloga@zumper.com (Sarah Walloga)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  standard set of environment variables
 * see here for details: https://zumper.atlassian.net/wiki/spaces/PLAT/pages/225640562/DevOps+Users+Guide#Environment-Variables
 */

import { getLiveEnv } from './getLiveEnv'

// We're "on browser" when we have a window.
export let IS_BROWSER =
  typeof window !== 'undefined' && Boolean(window?.navigator?.platform)

/* istanbul ignore next */
export const mockIsBrowser = (status: boolean) => {
  IS_BROWSER = status
}

export const APP_NAME = getLiveEnv('REACT_APP_NAME')
export const isZumper = APP_NAME === 'Zumper'
export const isPadMapper = APP_NAME === 'PadMapper'
export const STACK_NAME = String(getLiveEnv('STACK_NAME', 'local'))
export const STACK_TYPE = String(getLiveEnv('STACK_TYPE', 'dev'))

export let ZUMPER_MODE = String(getLiveEnv('ZUMPER_MODE', 'dev'))
/* istanbul ignore next */
export const MODE = ZUMPER_MODE === 'prod' ? 'prod' : 'dev'
/* istanbul ignore next */
export let IS_PRODUCTION =
  STACK_NAME === 'main' && STACK_TYPE === 'prod' && MODE === 'prod'
export let IS_POKE = !IS_PRODUCTION && STACK_TYPE === 'test'
export let IS_LOCAL_DEV = !IS_PRODUCTION && !IS_POKE

/* istanbul ignore next */
export const mockIsProduction = (status: boolean) => {
  IS_PRODUCTION = status
}

/* istanbul ignore next */
export const mockIsPoke = (status: boolean) => {
  IS_POKE = status
}

/* istanbul ignore next */
export const mockIsLocal = (status: boolean) => {
  IS_LOCAL_DEV = status
}

/* istanbul ignore next */
export const mockZumperMode = (status: string) => {
  ZUMPER_MODE = status
}
